import React, { useState, useEffect } from "react";
import { Card, CardMedia, CardContent, Typography, Grid, Link, Button, Stack, } from "@mui/material";
import dayjs from "dayjs";
import { useNoticia } from "../hooks/useNoticia";
import { useTools } from "../hooks/useTools";
import { useLocation, useNavigate } from "react-router-dom";
import { NoticiasSkeleton } from "../components/commons/NoticiasSkeleton";
import { useTranslation } from "react-i18next";
import "../styles/Noticias.css";
import Parser from "html-react-parser";
import { Box } from "@mui/system";

export const ListaNoticias = ({ cantidadNoticias, justify }) => {
    const { getNoticiaByNumber } = useNoticia()
    const { removeTags, scrollToTop } = useTools()
    const [listaNoticias, setListaNoticias] = useState(null)
    const navigate = useNavigate()
    const { t } = useTranslation();
    const location = useLocation();

    useEffect(() => {
      if (listaNoticias == null) {
        var obtenerNoticias = getNoticiaByNumber(cantidadNoticias, null)
        obtenerNoticias.then(
          (promiseFullfilled) => {
            setListaNoticias(promiseFullfilled)
          },
          (promiseError) => {
            console.error("Error: " + promiseError)
          }
        );
      }
    }, []);

    function goToAllNews() {
      navigate("/Noticias");
    }

    function goToNoticia(key) {
      navigate("/Noticia/" + key)
      scrollToTop()
    }

    function textForNotice(noticia) {
        if(!noticia.texto) return
        let textWithoutTags = removeTags(noticia.texto)
        let textParse = Parser(textWithoutTags)
        if (textParse.length < 500) return textParse
        return textParse.substring(0, (noticia.imagenURL ? 350 : 500) + (noticia.titulo.length < 36 ? + noticia.titulo.length : - noticia.titulo.length)) + "..."
    }

    return (
      <>
        {listaNoticias?.length > 0 &&
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            marginTop={4}
          >
            {location.pathname !== "/Noticias" && (
              <Typography variant="h6" color="primary" sx={{ fontSize: '2.5em' }}>
                {t('Noticias.noticiasRecientes')}
              </Typography>
            )}
            <Grid container spacing={1} justifyContent={justify}>
              {listaNoticias && listaNoticias.length > 0 ? (
                listaNoticias.map((noticia, index) =>
                  <Grid item xs={12} sm={4} lg={3} key={index}>
                    <Card sx={{ height: '100%' }}>
                      
                      {noticia.imagenURL && 
                      <CardMedia
                        component="img"
                        height="150"
                        image={"data:image/png;base64," +noticia.imagenURL}
                        alt={noticia.titulo + " imagen"}
                      />}
                      
                      <CardContent className="newsCard" sx={{ display: 'flex', flexDirection: 'column', minHeight: '350px' }}>
                        {noticia.fecha_creacion && (
                          <Typography gutterBottom variant="caption" component="div">
                            {dayjs(noticia.fecha_creacion).format("DD/MM/YYYY")}
                          </Typography>
                        )}
                        <Typography gutterBottom variant="body1" fontWeight={"bold"} component="div">
                          {removeTags(noticia.titulo)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {/* He calculado que el minimo son los 36 caracteres -> Si < 50 suma la longitud del titulo al texto sino lo resta*/}
                            {/* En caso de que no haya imagen le añado al texto de preview 150 caracteres mas para ocupar el espacio que dejaría la imagen */}
                            {textForNotice(noticia)}
                        </Typography>
                        <div style={{ marginTop: 'auto' }}>
                          <Link
                            underline="hover"
                            variant="body2"
                            marginTop={1}
                            onClick={() => { goToNoticia(noticia.key) }}
                            sx={{ cursor: 'pointer' }}
                          >
                            {t("Noticias.leermas")}
                          </Link>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>

                )
              ) :
                (
                  <NoticiasSkeleton />
                )}
            </Grid>
            {listaNoticias.length >= 4 && location.pathname !== "/Noticias" && (
              <Box>
                <Button
                  variant="contained"
                  onClick={() => {
                    goToAllNews();
                  }}
                >
                  {t("Noticias.verNoticias")}
                </Button>
              </Box>
            )}
          </Stack>
        }
      </>
    )
  }
